import { CLEAR_NETWORK_BROWSE_FILTERS } from 'actions';

export default function clearNetworkBrowseFilters() {
  return {
    type: CLEAR_NETWORK_BROWSE_FILTERS,
  };
}
